export const createReducer = (initialState, reducerMap) => {
	return (state = initialState, action) => {
		const reducer = reducerMap[action.type];
		return reducer ? reducer(state, action.payload) : state;
	};
};

export default { createReducer };


// WEBPACK FOOTER //
// ./src/utils/index.js